import { Checkbox, RadioGroup, Select } from "@mobiscroll/react5";
import { useEffect, useState } from "react";


export const PlanCard = ({ plan, plans, selectedPlan }) => {

    const getDuration = (interval, period) => {

        // Map period to readable unit
        const periodMap = { daily: "day", weekly: "week", monthly: "month", yearly: "year", };

        // Quarterly (monthly interval)
        if (period === "monthly" && interval === 3) {
            return "per quarter";
        }

        // Quarterly (yearly interval)
        if (period === "yearly" && interval === 3) {
            return "every 3 months";
        }

        // Half-yearly
        if (period === "yearly" && interval === 2) {
            return "every 6 months";
        }

        // General case
        let unit = periodMap[period] || "period";
        if (interval === 1) {
            return ` per ${unit}`;
        } else {
            return ` every ${interval} ${unit}${interval > 1 ? "s" : ""}`;
        }

    };

    const [list, setList] = useState([]);

    useEffect(() => {
        setList(plan?.item?.description?.split("\n").filter((itm) => itm));
    }, [plan]);

    if (!plan || !plan.item) {
        return (
            <div className="text-center text-muted">
                Plan details not available.
            </div>
        );
    }

    return (
        <div className="docg-card docg-pricing docg-plan rounded p-4 border">
            <div className="d-flex upper-portion flex-column">
                <div className="d-flex align-items-start gap-2">
                    <span className="pricing">
                        &#8377; {Number(plan.item.amount / 100).toLocaleString("en-US")}{" "}
                    </span>
                    <span className="duration">
                        {getDuration(plan?.interval, plan?.period)}
                        {plan?.applicableTaxVerbiage ? " + " + plan?.applicableTaxVerbiage : null}
                    </span>
                </div>
                {plan?.companyPercentage >= 0 ? (
                    <span>
                        Payment Fee: <span style={{ color: '#c06c84', fontSize: '1.2rem', fontWeight: '500' }}>{plan?.companyPercentage}%</span>{" "}{plan?.verbiageForTransactFee}{" "}
                    </span>
                ) : null}
            </div>

            <hr style={{ borderTop: "3px solid rgba(180, 180, 180)" }} />

            <div className="d-flex description">
                <div className="d-flex flex-grow-1 h-full flex-column">
                    <div className="flex-grow-1 text-left" style={{ whiteSpace: "pre-line" }}>
                        <b>This Subscription plan includes:</b>
                        {list.map((itm, i) => (
                            <div className="custom-repeat-checkbox-cont" key={i}>
                                <Checkbox checked={true}>{itm}</Checkbox>
                            </div>
                        ))}
                    </div>
                    <div className="custom-repeat-radio-cont"></div>
                </div>
            </div>
        </div>
    );
};